/**
 * Geometry for the Dynamic Island launcher pill.
 *
 * The launcher lives inside the iframe, but the host sizes the iframe from the
 * outside. Both sides derive their numbers here so the iframe is never smaller
 * than the pill it has to contain.
 */

/** Pill height and the horizontal padding that shapes it. */
export const ISLAND_HEIGHT_PX = 60;
export const ISLAND_MAX_WIDTH_PX = 700;
export const ISLAND_MIN_WIDTH_PX = 280;

/** Distance from the viewport bottom. */
export const ISLAND_MARGIN_PX = 24;

/**
 * Slack around the pill inside the iframe. The pill scales on hover and casts a
 * soft shadow; both would be clipped by an iframe sized to the pill alone.
 */
export const ISLAND_BLEED_PX = 40;

/** Viewport share the pill may occupy before it starts shrinking. */
const VIEWPORT_RATIO = 0.86;

export function getIslandWidthPx( viewportWidthPx: number ): number {
	const available = Math.round( viewportWidthPx * VIEWPORT_RATIO );
	const clamped = Math.min( ISLAND_MAX_WIDTH_PX, available );
	return Math.max( ISLAND_MIN_WIDTH_PX, clamped );
}

/**
 * Iframe box that holds the collapsed pill, including bleed for shadow/hover.
 *
 * Capped at the viewport: the pill's own floor (ISLAND_MIN_WIDTH_PX) plus the
 * bleed either side exceeds a narrow phone, and an iframe wider than the
 * screen hangs off both edges -- which pushes the pill's gap to the right out
 * of step with its gap to the bottom.
 * @param viewportWidthPx Width of the host viewport in px.
 */
export function getIslandIframeSizePx( viewportWidthPx: number ): {
	width: number;
	height: number;
} {
	const wanted = getIslandWidthPx( viewportWidthPx ) + 2 * ISLAND_BLEED_PX;
	return {
		width: Math.min( wanted, viewportWidthPx ),
		height: ISLAND_HEIGHT_PX + ISLAND_MARGIN_PX + ISLAND_BLEED_PX,
	};
}
